import React, { useState } from "react";

/**
 * Sandbox para visualizar elementos antes de integrarlos.
 * Agrega tus componentes al arreglo `PREVIEWS`.
 */
const TOGGLE_CSS = `
.sw{position:relative;border:none;padding:0;cursor:pointer;background:#bdc1c8;transition:background-color .25s;outline:none}
.sw:disabled{opacity:.6;cursor:not-allowed}
.sw.on{background:#29b5a8}
.sw.on.warn{background:#ff8300}
.sw .handle{position:absolute;background:#fff;border-radius:50%;transition:left .25s}
.sw.sw-md{width:3rem;height:1.5rem;border-radius:1.5rem}
.sw.sw-md .handle{top:.1875rem;left:.1875rem;width:1.125rem;height:1.125rem}
.sw.sw-md.on .handle{left:1.6875rem}
.sw.sw-lg{width:5rem;height:2.5rem;border-radius:2.5rem}
.sw.sw-lg .handle{top:.3125rem;left:.3125rem;width:1.875rem;height:1.875rem}
.sw.sw-lg.on .handle{left:2.8125rem}
.sw.sw-xs{width:2rem;height:1rem;border-radius:1rem}
.sw.sw-xs .handle{top:.125rem;left:.125rem;width:.75rem;height:.75rem}
.sw.sw-xs.on .handle{left:1.125rem}
`;

function Toggle({ checked, onChange, size = "md", warn = false, disabled = false, label }) {
  return (
    <>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        disabled={disabled}
        className={`sw sw-${size} ${checked ? "on" : ""} ${warn ? "warn" : ""}`}
        onClick={() => onChange(!checked)}
      >
        <span className="handle" />
      </button>
    </>
  );
}

function ToggleDemo() {
  const [a, setA] = useState(false);
  const [b, setB] = useState(true);
  return (
    <div>
      <style>{TOGGLE_CSS}</style>
      {["lg", "md", "xs"].map((s) => (
        <div key={s} className="d-flex align-items-center mb-3" style={{ gap: 24 }}>
          <span style={{ width: 60 }}>{s}</span>
          <Toggle size={s} checked={a} onChange={setA} label={`toggle ${s}`} />
          <Toggle size={s} checked={b} onChange={setB} warn label={`toggle warn ${s}`} />
        </div>
      ))}
      <Toggle checked disabled onChange={() => {}} label="deshabilitado" />
    </div>
  );
}

const PREVIEWS = [
  {
    id: "toggle-onoff",
    titulo: "Toggle On/Off (CodePen aanjulena)",
    render: () => <ToggleDemo />,
  },
  {
    id: "ejemplo-card",
    titulo: "Ejemplo: tarjeta",
    render: () => (
      <div className="card shadow">
        <div className="card-body">
          <h5 className="card-title">Título de ejemplo</h5>
          <p className="card-text mb-0">Reemplaza este bloque con tu elemento.</p>
        </div>
      </div>
    ),
  },
  {
    id: "ejemplo-botones",
    titulo: "Ejemplo: botones",
    render: () => (
      <div className="d-flex" style={{ gap: 8 }}>
        <button className="btn btn-primary">Primario</button>
        <button className="btn btn-success">Éxito</button>
        <button className="btn btn-danger">Peligro</button>
      </div>
    ),
  },
];

const FONDOS = {
  claro: "#ffffff",
  gris: "#f8f9fc",
  oscuro: "#343a40",
};

export default function Testing() {
  const [activo, setActivo] = useState(PREVIEWS[0]?.id);
  const [fondo, setFondo] = useState("gris");
  const [ancho, setAncho] = useState("100%");

  const seleccionado = PREVIEWS.find((p) => p.id === activo);

  return (
    <div className="container-fluid">
      <h1 className="h3 mb-3 text-gray-800">Testing de componentes</h1>

      <div className="card shadow mb-3">
        <div className="card-body d-flex flex-wrap align-items-center" style={{ gap: 12 }}>
          <select className="form-control w-auto" value={activo} onChange={(e) => setActivo(e.target.value)}>
            {PREVIEWS.map((p) => (
              <option key={p.id} value={p.id}>{p.titulo}</option>
            ))}
          </select>

          <select className="form-control w-auto" value={fondo} onChange={(e) => setFondo(e.target.value)}>
            {Object.keys(FONDOS).map((f) => (
              <option key={f} value={f}>Fondo: {f}</option>
            ))}
          </select>

          <select className="form-control w-auto" value={ancho} onChange={(e) => setAncho(e.target.value)}>
            <option value="100%">Escritorio (100%)</option>
            <option value="768px">Tablet (768px)</option>
            <option value="375px">Móvil (375px)</option>
          </select>
        </div>
      </div>

      <div className="border rounded p-3" style={{ background: FONDOS[fondo], overflowX: "auto" }}>
        <div style={{ width: ancho, margin: "0 auto" }}>
          {seleccionado ? seleccionado.render() : <em>Sin previews registrados.</em>}
        </div>
      </div>
    </div>
  );
}
